import { render, staticRenderFns } from "./FormCOSCases.vue?vue&type=template&id=427e55ec&scoped=true&lang=pug"
import script from "./FormCOSCases.vue?vue&type=script&lang=ts"
export * from "./FormCOSCases.vue?vue&type=script&lang=ts"
import style0 from "./FormCOSCases.vue?vue&type=style&index=0&id=427e55ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e55ec",
  null
  
)

export default component.exports